import { ManagementComponent } from '../management.component';
import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import * as clipboard from 'clipboard-polyfill';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-shipments',
  templateUrl: './shipments.component.html',
  styleUrls: ['./shipments.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ShipmentsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();  // ✅ Subject for cleanup

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) {
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

     // Debounce search.
     this.partnerSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      takeUntil(this.destroy$))  // ✅ Auto-unsubscribe on destroy
      .subscribe(value => {
        if(value?.length >= 1){
          this.FilterPartnerSearchTerm = value;
          this.GetPartnersFiltered();
        }
      });

       // Debounce search.
     this.trackingStatusSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      takeUntil(this.destroy$))  // ✅ Auto-unsubscribe on destroy
      .subscribe(value => {
        if(value?.length >= 1){
          this.FilterTrackingStatus = value;
          this.GetTrackingStatuses();
        }
      });

     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$))  // ✅ Auto-unsubscribe on destroy
      .subscribe(value => {
        this.SearchTerm = value;

      });

     // Debounce main search.
     this.mainSearchTermUpdate.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$))  // ✅ Auto-unsubscribe on destroy
      .subscribe(value => {
        this.MainSearchTerm = value;
        if (value && value.trim().length > 0) {
          this.SearchShipmentsFTS();
        } else {
          this.GetShipmentsFiltered();
        }
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  partnerSearchTermUpdate = new Subject<string>();
  searchTermUpdate = new Subject<string>();
  trackingStatusSearchTermUpdate = new Subject<string>();
  mainSearchTermUpdate = new Subject<string>();  // ✅ Main search box

  showFilter:boolean = false;
  SearchTerm:string;
  MainSearchTerm:string = '';  // ✅ Main search term

  // Custom Dropdown visibility flags
  showPartnerDropdown:boolean = false;
  showShippingCompanyDropdown:boolean = false;
  showCompanyDropdown:boolean = false;
  showShippingServiceTypeDropdown:boolean = false;
  showShippingDirectionDropdown:boolean = false;
  showTrackingStatusDropdown:boolean = false;
  showShippingCostStatusDropdown:boolean = false;
  showCountryDropdown:boolean = false;

  ShippingResponsabilities:any[];
  ShippingServiceTypes:any[];
  ShippingWays:any[];
  ShippingCompanies:any[];
  WeightTypes:any[];
  Directions:any[];
  ShippingDetails: {[k: string]: any} = {};
  Companies:any[];

  Filter: {[k: string]: any} = {};
  FilterPartnerSearchTerm:string;
  FilterTrackingStatus:string;
  FilterCountrySearchTerm:string = '';

  get FilteredCountries(): any[] {
    if (!this.parent.masterData?.Countries) {
      return [];
    }
    if (!this.FilterCountrySearchTerm || this.FilterCountrySearchTerm.trim() === '') {
      return this.parent.masterData.Countries;
    }
    const searchTerm = this.FilterCountrySearchTerm.toLowerCase();
    return this.parent.masterData.Countries.filter((c: any) =>
      c.Name?.toLowerCase().includes(searchTerm)
    );
  }

  SelectedShippingCompany:any;
  TrackEvents:any[];
  CurrentTracking:any;

  Courier:string;
  Tracking:string;
  Shipments:any[];
  Partners:any[];
  TrackingStatuses:any[];

  TrackAllAtOnce:boolean = false;
  ShippingCostStatuses:any[];

  ShowTrackHistory:boolean = false;

  ngOnInit(): void {
    this.InitializeFilter();
    this.GetShippingMasterData();
  }

  GetPartnersFiltered(){
    var request = {
      SearchTerm:this.FilterPartnerSearchTerm,
      CountryID:this.Filter.Country?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager?.PageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Filter.Company?.ID
    };

    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
      }
   
      this.parent.loading = false;
    });
  }

  GetTrackingStatuses(){
    var request = {
      SearchTerm:this.FilterTrackingStatus,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetTrackingStatuses(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.TrackingStatuses = response["TrackingStatuses"];
      }
   
      this.parent.loading = false;
    });
  }

  InitializePartners(){
    if(this.Partners == null || this.Partners.length == 0){
      this.Filter.Pager.PageIndex = 1;
      this.FilterPartnerSearchTerm = "";
      this.GetPartnersFiltered();
    }
  }

  InitializeTrackingStatus(){
    if(this.TrackingStatuses == null || this.TrackingStatuses.length == 0){
      this.FilterTrackingStatus = "";
      this.GetTrackingStatuses();
    }
  }

  InitializeCompanies(){
    if(this.Companies == null || this.Companies.length == 0){
      this.GetAllCompanies();
    }
  }

  GetAllCompanies(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
   };
 
  this.parent.loading = true;
 
  this.service.GetAllCompanies(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Companies = response["Companies"];
    }
 
    this.parent.loading = false;
   });
   }

  ClearPartnerBrand(){

    if(this.Filter != null){
      this.Filter.Partner = {};
    }

    this.Filter.Partner = null;
    this.Partners = [];
    this.FilterPartnerSearchTerm = "";
   }

   ClearTrackingStatus(){

    if(this.Filter != null){
      this.Filter.TrackingStatus = {};
    }

    this.Filter.TrackingStatus = null;
    this.TrackingStatuses = [];
    this.FilterTrackingStatus = "";
   }

   ClearCountry(){

    if(this.Filter != null){
      this.Filter.Country = {};
    }

    this.Filter.Country = null;
   }

  InitializeFilter(){
    this.Filter.ShippingCompany = {};
    this.Filter.ShippingCompany = null;

    this.Filter.Partner = {};
    this.Filter.Partner = null;

    this.Filter.Company = {};
    this.Filter.Company = null;

    this.Filter.ShippingServiceType = {};
    this.Filter.ShippingServiceType = null;

    this.Filter.ShippingDirection = {};
    this.Filter.ShippingDirection = null;

    this.Filter.TrackingStatus = {};
    this.Filter.TrackingStatus = null;

    this.Filter.Country = {};
    this.Filter.Country = null;

    this.Filter.SearchTerm = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;
  }

  GetShippingMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetShippingMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.ShippingResponsabilities = response["ShippingResponsabilities"];
     this.ShippingServiceTypes = response["ShippingServiceTypes"];
     this.ShippingWays = response["ShippingWays"];
     this.ShippingCompanies = response["ShippingCompanies"];
     this.WeightTypes = response["WeightTypes"];
     this.Directions = response["Directions"];
     this.Filter.ShippingDirection = this.Directions[0];
     this.ShippingCostStatuses = response["ShippingCostStatuses"];
    }
 
    this.LoadShipments();
    this.parent.loading = false;
   });
   }

   // Smart wrapper: Use FTS if search term exists, otherwise use regular filtered query
   LoadShipments(){
     if(this.MainSearchTerm && this.MainSearchTerm.trim().length > 0){
       this.SearchShipmentsFTS();
     } else {
       this.GetShipmentsFiltered();
     }
   }

   GetShipmentsFiltered(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     Filter:this.Filter
   };

  this.parent.loading = true;

  this.managementService.GetShipmentsFiltered(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Shipments = response["Shipments"];
      this.Filter.Pager = response["Pager"];
      this.showFilter = false;
    }

    this.parent.loading = false;
   });
   }

   SearchShipmentsFTS(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     Filter:{
       ...this.Filter,
       SearchTerm: this.MainSearchTerm || this.Filter.SearchTerm
     }
   };

  this.parent.loading = true;

  this.managementService.SearchShipmentsFTS(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Shipments = response["Shipments"];
      this.Filter.Pager = response["Pager"];
    }

    this.parent.loading = false;
   });
   }

   Attachments:any[];

   GetAttachments(TrackingLabel:string, ShippingCompany:number){
    this.ShippingDetails.ShippingCompany = ShippingCompany;
    this.ShippingDetails.TrackingLabel = TrackingLabel;

    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     ShippingDetails:this.ShippingDetails
   };
 
  this.parent.loading = true;
 
  this.managementService.PrintShippingLabel(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShippingDetails = response["ShippingDetails"];
      this.Attachments = this.ShippingDetails.Documents;
    }
 
    this.parent.loading = false;
   });
   }

   PrintShippingLabel(TrackingLabel:string, ShippingCompany:number, ShippingDetailsID:number = null){

    this.ShippingDetails.ShippingCompany = ShippingCompany;
    this.ShippingDetails.TrackingLabel = TrackingLabel;
    this.ShippingDetails.ID = ShippingDetailsID;

    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     ShippingDetails:this.ShippingDetails
   };
 
  this.parent.loading = true;
 
  this.managementService.PrintShippingLabel(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShippingDetails = response["ShippingDetails"];
      
      for(var i=0; i < this.ShippingDetails.Documents.length; i++){
          this.parent.printPage(this.ShippingDetails.Documents[i].Name , this.ShippingDetails.Documents[i].PDFStream, this.ShippingDetails.Documents[i].ID);
      }
    }
 
    this.parent.loading = false;
   });
   }

   CopyLabel(s:any){
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/new/shipment'], { queryParams: { copy: true, shipment: s.ShippingDetailsID, direction: s.ShippingDirection.ID } }));
    window.open(nextUrl, '_blank');
   }

   CopyLabelShippingDetails(){
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/new/shipment'], { queryParams: { copy: true, shipment: this.ShippingDetails.ID, direction: this.ShippingDetails.ShippingDirection.ID } }));
    window.open(nextUrl, '_blank');
   }

   TrackShippingLabel(s:any, showPop:boolean = true){

    this.CurrentTracking = s;
    this.ShippingDetails.ShippingCompany = s.ShippingCompany;
    this.ShippingDetails.TrackingLabel = s.TrackingLabel;
    this.ShippingDetails.ShippingDirection = this.Filter.ShippingDirection;
    this.ShippingDetails.ID = s.ShippingDetailsID;

    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     ShippingDetails:this.ShippingDetails
   };
 
  this.parent.loading = true;
 
  this.managementService.TrackShippingLabel(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShippingDetails = response["ShippingDetails"];
      this.TrackEvents = this.ShippingDetails.TrackHistory;

      if(showPop == true){
        this.ShowTrackHistory = true;
        this.ShowTrackDetails = false;
      }
    }
 
    this.parent.loading = false;
   });
   }
   
   ShowTrackDetails:boolean = false;

   GetShippingDetails(ID:number, DirectionID:number){
    
    var Direction = this.Directions?.filter(x => x.ID == DirectionID)[0];
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetailsID:ID,
      ShippingDirection:Direction,
      GetStatistics:true,
    };

    this.parent.loading = true;

    this.managementService.GetShippingDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingDetails = response["ShippingDetails"];
        this.ShowTrackDetails = true;
      }
   
      this.parent.loading = false;
    });
  }

  activeFilters:{[k: string]: any} = [];

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Company"){
      this.Filter.Company = null;
    }
    else if(filterType == "ShippingCompany"){
      this.Filter.ShippingCompany = null;
    }
    else if(filterType == "ShippingServiceType"){
      this.Filter.ShippingServiceType = null;
    }
    else if(filterType == "TrackingStatus"){
      this.Filter.TrackingStatus = null;
    }
    else if(filterType == "Country"){
      this.Filter.Country = null;
    }
    else if(filterType == "SearchTerm"){
      this.Filter.SearchTerm = null;
    }

    this.Filter.Pager.PageIndex = 1;
    this.LoadShipments();
  }

  AllSelected:boolean = false;

  AnyChecked:boolean = false;

  CheckIfAnyChecked(){
    this.AnyChecked = false;

    this.Shipments.forEach(element => {
      if(element.IsSelected){
        this.AnyChecked = true;
      }
    });
  }

  SelectAll(){
    this.Shipments.forEach(s => {
      s.IsSelected = this.AllSelected;
    });
  
    this.CheckIfAnyChecked();
  }

  NewLabel(){
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/new/shipment']));
    window.open(nextUrl, '_blank');
  }

  ShowShipmentsStatusUpdateContainer:boolean = false;

  PrepareShipmentsStatusUpdate(){
    this.ShowShipmentsStatusUpdateContainer = true;
  }

  TrackShippingLabelsBulk(){
    
    var shipments = this.Shipments.filter(x => x.IsSelected == true);
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      TrackAllAtOnce:this.TrackAllAtOnce,
      Shipments:shipments
    };

    this.parent.loading = true;

    this.managementService.TrackShippingLabelsBulk(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowShipmentsStatusUpdateContainer = false;
      }
   
      this.parent.loading = false;
    });
  }

  SwitchDirection(){
    if(this.Filter.ShippingDirection.ID == this.Directions[0].ID){
      this.Filter.ShippingDirection = JSON.parse(JSON.stringify(this.Directions[1]));
    }
    else{
      this.Filter.ShippingDirection = JSON.parse(JSON.stringify(this.Directions[0]));
    }

    this.LoadShipments();
  }

  ShowDeleteLabelQuestion:boolean = false;

  GetShippingDetailsForDeleteRequest(ID:number, DirectionID:number){
    
    var Direction = this.Directions?.filter(x => x.ID == DirectionID)[0];
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetailsID:ID,
      ShippingDirection:Direction,
      GetStatistics:true,
    };

    this.parent.loading = true;

    this.managementService.GetShippingDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingDetails = response["ShippingDetails"];

        if(this.ShippingDetails != null){
          this.ShowDeleteLabelQuestion = true;
        }
      }
   
      this.parent.loading = false;
    });
  }

  DeleteShippingLabel(){
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:this.ShippingDetails
    };

    this.parent.loading = true;

    this.managementService.DeleteShippingLabel(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.LoadShipments();
      }

      this.parent.loading = false;
    });
  }

  ShowForceQuestion:boolean = false;

  OpenForceQuestion(s:any){
    this.ShowForceQuestion = true;
    this.ShippingDetails = s;
  }

  ForceShipmentClose(){
    
    var ForceClose = true;

    if(this.ShippingDetails.ForceClose == true){
      ForceClose = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetailsID:this.ShippingDetails.ShippingDetailsID,
      ShippingDirection:this.ShippingDetails.ShippingDirection,
      Force:ForceClose
    };

    this.parent.loading = true;

    this.managementService.ForceShipmentClose(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.LoadShipments();
      }

      this.parent.loading = false;
    });
  }

  UpdateShippingDetailsTrackingStatus(){

    var ev = null;

    if(this.TrackEvents != null && this.TrackEvents?.length > 0){
      ev = this.TrackEvents[0];
    }

    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     ShippingDetailsID:this.CurrentTracking?.ShippingDetailsID,
     CurrentTrackEvent:ev?.Event,
     CurrentTrackEventInternalStatus:ev?.Status.ID,
     ErrorMessage:this.ShippingDetails.Error?.Message,
     ErrorCode:this.ShippingDetails.Error?.Code,
     CurrentTrackEventDateTime:ev?.Date,
     DirectionID:this.Filter.ShippingDirection?.ID
   };
 
  this.parent.loading = true;
 
  this.managementService.UpdateShippingDetailsTrackingStatus(request).subscribe(response => {

    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.LoadShipments();
    }

    this.ShowTrackHistory = false;
    this.parent.loading = false;
   });
  }

  ShowInitializeRequestPickup:boolean = false;

   InitializeRequestPickup(s:any){
    this.CurrentTracking = s;
    this.ShowInitializeRequestPickup = true;
   }

   GetShippingDetailsForPickup(ID:number, DirectionID:number){
    
    var Direction = this.Directions?.filter(x => x.ID == DirectionID)[0];
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetailsID:ID,
      ShippingDirection:Direction,
      GetStatistics:true,
    };

    this.parent.loading = true;

    this.managementService.GetShippingDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingDetails = response["ShippingDetails"];
      }
   
      this.parent.loading = false;
    });
  }

   RequestPickup(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingDetails:this.ShippingDetails,
    };

    this.parent.loading = true;

    this.managementService.RequestPickup(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingDetails = response["ShippingDetails"];
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 20000);
      }
   
      this.parent.loading = false;
    });
   }

   ShowEmailNotificationContainer:boolean;
   SupportContacts:any[];
   CurrentSupportContact:any;
   SupportShippingCompany:any;

   GetShippingCompanySupportEmailData(s:any){

    this.ShippingCompanies.forEach(element => {
      if(element.ID == s.ShippingCompany?.ID){
        
      }
    });

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Tracking:s
    };

    this.parent.loading = true;

    this.service.GetShippingCompanySupportEmailData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SupportShippingCompany = response["ShippingCompany"];
        this.SupportContacts = this.SupportShippingCompany.SupportContacts;
        this.SelectSupportCategory(JSON.parse(JSON.stringify(this.SupportContacts.filter(x => x.Category.IsSelected == true)[0])));

        this.GetCompanySMTPConfigs(this.parent.getLanguage());
      }
   
      this.parent.loading = false;
    });
   }

   SelectSupportCategory(s:any){
    this.CurrentSupportContact = null;
    this.SupportContacts.forEach(element => {
      if(element.Category.ID != s.Category.ID){
        element.Category.IsSelected = false;
      }
      else{
        element.Category.IsSelected = true;
        this.CurrentSupportContact = JSON.parse(JSON.stringify(s));
      }
    });


   }

SMTPConfigs:any[];
CurrentSMTP:any;
SMTPEmails:any[];
CurrentSMTPEmail:any;
EmailMessage:any;
EmailSubject:string;
EmailNotificationMessage:string;

GetCompanySMTPConfigs(Language:string){
  var request = {
    User:this.parent.User,
    Language:Language,
    UILanguage:this.parent.getLanguage(),
    CompanyID:this.parent.Company.ID
  };

  this.parent.loading = true;

  this.service.GetCompanySMTPConfigs(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SMTPConfigs = response["SMTPConfigs"];

      if(this.SMTPConfigs.length > 0){
        this.CurrentSMTP = this.SMTPConfigs[0];
        this.GetCompanySMTPEmails(this.CurrentSMTP.ID, Language);
      }
    }
   
    this.parent.loading = false;
  });
}

GetCompanySMTPEmails(SMTPID:any, Language:string){
  var request = {
    User:this.parent.User,
    Language:Language,
    UILanguage:this.parent.getLanguage(),
    SMTPID:SMTPID
  };

  this.parent.loading = true;

  this.service.GetCompanySMTPEmails(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SMTPEmails = response["Emails"];

      this.SMTPEmails.forEach(e => {
        if(e.Email == this.parent.User.Email){
          e.IsDefault = true;
        }
        else{
          e.IsDefault = false;
        }
      });

      this.ShowEmailNotificationContainer = true;
    }
   
    this.parent.loading = false;
  });
}

SelectSMTPEmail(model:any){
  this.SMTPEmails.forEach(e => {
    if(e.ID == model.ID){
      e.IsDefault = true;
    }
    else{
      e.IsDefault = false;
    }
  });
}

Agents:any[];

RemoveUserFromMessage(u:any){
  this.Agents = this.Agents.filter(x => x.ID != u.ID);
 }

 SendContactSupportEmail(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SMTP:this.CurrentSMTP,
    FromEmail:this.SMTPEmails.filter(x => x.IsDefault == true)[0],
    ToEmails:this.CurrentSupportContact.Emails,
    Subject:this.CurrentSupportContact.Subject,
    Body:this.CurrentSupportContact.Body,
    Attachments:this.Attachments,
    ShippingDetails:this.ShippingDetails,
  };

  this.parent.loading = true;

  this.managementService.SendContactSupportEmail(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
    }
   
    this.ShowEmailNotificationContainer = false;
    this.parent.loading = false;
  });
 }

 ShowShipmentDetails(s:any){

  this.TrackEvents = [];
  this.TrackEvents = null;
  this.ShowShippingLog = true;
  this.ShowTrackingLog = false;

  this.Shipments.forEach(element => {
    if(element.ShippingDetailsID == s.ShippingDetailsID){
      element.ShowDetails = true;

      if(!this.GridShippingDetails || this.GridShippingDetails?.ID != s.ShippingDetailsID){
        this.GetShippingDetailsFromGrid(element.ShippingDetailsID, element.ShippingDirection.ID);
      }
      else{
        this.GridShippingDetails = null;
        element.ShowDetails = false;
      }
    }
    else{
      element.ShowDetails = false;
    }
  });
 }

 loadingFromGrid:boolean = false;
 ShowShippingLog:boolean = true;
 ShowTrackingLog:boolean = false;
 trackEventsLoading:boolean = false;

 SelectShippingLog(){
  this.ShowTrackingLog = false;
  this.ShowShippingLog = true;
  this.TrackEvents = [];
  this.TrackEvents = null;
 }

 SelectTrackingLog(s:any){

  this.TrackEvents = [];
  this.TrackEvents = null;

  this.ShowTrackingLog = true;
  this.ShowShippingLog = false;

  this.CurrentTracking = s;
  this.ShippingDetails.ShippingCompany = s.ShippingCompany;
  this.ShippingDetails.TrackingLabel = s.TrackingLabel;
  this.ShippingDetails.ShippingDirection = this.Filter.ShippingDirection;
  this.ShippingDetails.ID = s.ShippingDetailsID;

  var request = {
   User:this.parent.User,
   Language:this.parent.getLanguage(),
   ShippingDetails:this.ShippingDetails
 };

this.trackEventsLoading = true;

this.managementService.TrackShippingLabel(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
    this.ShippingDetails = response["ShippingDetails"];
    this.TrackEvents = this.ShippingDetails.TrackHistory;
  }

  this.trackEventsLoading = false;
 });
 }

 GridShippingDetails:any;

 GetShippingDetailsFromGrid(ID:number, DirectionID:number){
    
  var Direction = this.Directions?.filter(x => x.ID == DirectionID)[0];
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingDetailsID:ID,
    ShippingDirection:Direction,
    GetStatistics:true,
  };

  this.loadingFromGrid = true;

  this.managementService.GetShippingDetails(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.GridShippingDetails = response["ShippingDetails"];
    }
 
    this.loadingFromGrid = false;
  });
}

// ✅ Clear main search
ClearMainSearch(){
  this.MainSearchTerm = '';
  this.mainSearchTermUpdate.next('');
}

ngOnDestroy(): void {
  // ✅ Emit destroy signal to unsubscribe all observables
  this.destroy$.next();
  this.destroy$.complete();
}

}
